import {
  FETCH_STATES,
  SET_STATES,
  SET_SELECTED_STATE,
  FETCH_MARKETS,
  SET_MARKETS,
  SET_SELECTED_MARKET,
  SET_SUPPLIERS,
  FETCH_ERROR,
  SET_CHARTSDATA,
  FETCH_CHARTSDATA,
  SET_SELECTED_TERM,
  SET_TERMS,
  SET_FROM_DATE,
  SET_TO_DATE,
  SET_EFFECTIVE_FROM_DATE,
  SET_EFFECTIVE_TO_DATE,
  SET_START_FROM_DATE,
  SET_START_TO_DATE,
  SET_NO_OF_MONTHS,
  SET_COMMODITY,
  SET_SELECTED_UTILITY,
  SET_SELECTED_RATE_CLASS,
  SET_SELECTED_LOAD_PROFILE,
  SET_SELECTED_LOAD_ZONE,
  SET_SELECTED_BILLING_METHOD,
  SET_USAGE,
  SET_DEMAND,
  SET_LOAD_FACTOR,
  SET_SELECTED_CLIENT_IDENTIFIER,
  SET_PRODUCT_TYPES,
  SET_SELECTED_ProductType,
  SET_COST_COMPONENTS,
  SET_SELECTED_COST_COMPONENT,
  SET_CUSTOMER_CLASS,
  SET_TAX_INCLUDED,
  SET_POR,
} from "../types/index";

export const fetchStates = () => ({
  type: FETCH_STATES,
});

export const setStates = (states: any) => ({
  type: SET_STATES,
  payload: states,
});

export const setSelectedState = (
  payload: { value: string; name: string } | null
) => ({
  type: SET_SELECTED_STATE,
  payload,
});

export const fetchMarkets = (commodity: string) => ({
  type: FETCH_MARKETS,
  payload: { commodity },
});

export const setMarkets = (markets: any) => ({
  type: SET_MARKETS,
  payload: markets,
});

export const setSelectedMarket = (
  payload: { value: string; name: string; commodity: string } | null
) => ({
  type: SET_SELECTED_MARKET,
  payload,
});

export const setTerms = (states: any) => ({
  type: SET_TERMS,
  payload: states,
});

export const setProductType = (states: any) => ({
  type: SET_PRODUCT_TYPES,
  payload: states,
});

export const setSelectedTerm = (termValue: string) => ({
  type: SET_SELECTED_TERM,
  payload: termValue,
});

export const setSelectedProductType = (termValue: string[]) => ({
  type: SET_SELECTED_ProductType,
  payload: termValue,
});

export const setFromDate = (dateValue: string) => ({
  type: SET_FROM_DATE,
  payload: dateValue,
});

export const setToDate = (dateValue: string) => ({
  type: SET_TO_DATE,
  payload: dateValue,
});

export const setEffectiveFromDate = (dateValue: string) => ({
  type: SET_EFFECTIVE_FROM_DATE,
  payload: dateValue,
});

export const setEffectiveToDate = (dateValue: string) => ({
  type: SET_EFFECTIVE_TO_DATE,
  payload: dateValue,
});

export const setStartFromDate = (dateValue: string) => ({
  type: SET_START_FROM_DATE,
  payload: dateValue,
});

export const setStartToDate = (dateValue: string) => ({
  type: SET_START_TO_DATE,
  payload: dateValue,
});

export const setNoOfMonths = (value: string) => ({
  type: SET_NO_OF_MONTHS,
  payload: value,
});

export const setCommodity = (commmodityIndex: number) => ({
  type: SET_COMMODITY,
  payload: commmodityIndex,
});

// export const fetchUtilities = (state: string, commodity: number) => ({
//   type: FETCH_UTILITIES,
//   payload: { state, commodity }
// });

// export const setUtilities = (utilities: any) => ({
//   type: SET_UTILITIES,
//   payload: utilities,
// });

export const setSelectedUtility = (
  payload: { value: string; name: string } | null
) => ({
  type: SET_SELECTED_UTILITY,
  payload,
});

// export const setLoadZones = (loadZones: any) => ({
//   type: SET_LOAD_ZONES,
//   payload: loadZones,
// });

// export const fetchLoadZones = (stateId: any) => ({
//   type: FETCH_LOAD_ZONES,
//   payload: stateId,
// });

export const setSelectedLoadZone = (
  payload: { value: string; name: string } | null
) => ({
  type: SET_SELECTED_LOAD_ZONE,
  payload,
});

export const setSelectedBillingMethod = (
  payload: { value: string; name: string } | null
) => ({
  type: SET_SELECTED_BILLING_METHOD,
  payload,
});

export const setSuppliers = (suppliers: any) => ({
  type: SET_SUPPLIERS,
  payload: suppliers,
});

// export const fetchRateClasses = () => ({
//   type: FETCH_RATE_CLASSES
// });

// export const setRateClasses = (rateClasses: any[]) => ({
//   type: SET_RATE_CLASSES,
//   payload: rateClasses,
// });

// export const setSelectedRateClasses = (SelectedRateClasses: any) => ({
//   type: SET_SELECTED_UTILITIES,
//   payload: SelectedRateClasses,
// });

export const setSelectedRateClass = (
  payload: { value: string; name: string } | null
) => ({
  type: SET_SELECTED_RATE_CLASS,
  payload,
});

export const setSelectedLoadProfile = (
  payload: { value: string; name: string } | null
) => ({
  type: SET_SELECTED_LOAD_PROFILE,
  payload,
});

export const setChartsData = (
  chartsData: any,
  key: string,
  isLoading?: boolean
) => ({
  type: SET_CHARTSDATA,
  payload: { key, chartsData, isLoading },
});

export const setChartsDataLoader = (isLoading: any, key: string) => ({
  type: SET_CHARTSDATA,
  payload: { key, isLoading },
});

export const fetchChartsData = (
  clientId?: string | null,
  selectedClientIdentifier?: string | null,
  userToken?: string | null,
  IsNotAnonymized: boolean = false,
  isSystemAdmin: boolean = false,
  isPremium: boolean | null = null
) => ({
  type: FETCH_CHARTSDATA,
  payload: {
    ...(clientId ? { clientId } : {}),
    ...(selectedClientIdentifier ? { selectedClientIdentifier } : {}),
    ...(userToken ? { userToken } : {}),
    IsNotAnonymized,
    isSystemAdmin,
    isPremium,
  },
});

export const fetchError = (error: string) => ({
  type: FETCH_ERROR,
  payload: error,
});

export const setUsage = (value: number | null) => ({
  type: SET_USAGE,
  payload: value,
});

export const setDemand = (value: number | null) => ({
  type: SET_DEMAND,
  payload: value,
});

export const setLoadFactor = (value: number | null) => ({
  type: SET_LOAD_FACTOR,
  payload: value,
});

export const setSelectedClientIdentifier = (value: string | null) => ({
  type: SET_SELECTED_CLIENT_IDENTIFIER,
  payload: value,
});

export const setCostComponents = (costComponents: any) => ({
  type: SET_COST_COMPONENTS,
  payload: costComponents,
});

export const setSelectedCostComponent = (costComponentValues: string[]) => ({
  type: SET_SELECTED_COST_COMPONENT,
  payload: costComponentValues,
});

export const setCustomerClass = (value: string | null) => ({
  type: SET_CUSTOMER_CLASS,
  payload: value,
});

export const setTaxIncluded = (value: boolean | null) => ({
  type: SET_TAX_INCLUDED,
  payload: value,
});

export const setPor = (value: boolean | null) => ({
  type: SET_POR,
  payload: value,
});
